import { AxiosRequestConfig } from 'axios';

import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import {
  baseOrderApiUrl,
  baseOrderCartApiUrl,
  baseOrderNonExternalApiUrl,
  baseOrderQuoteApiUrl,
} from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';
import { setUFOInteractionErrorCheck } from 'util/ufoUtils';
import { ORDER_INVOICE_ACTION_PDF_UFO_NAME } from 'util/ufoNameConstants';

export const getFromHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseOrderApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    setUFOInteractionErrorCheck(ORDER_INVOICE_ACTION_PDF_UFO_NAME);
    return Promise.reject(error);
  }
};

export const getFromHamsCartClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseOrderCartApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getFromHamsOrderQuoteClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseOrderQuoteApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getFromNonExternalHamsClient = async (
  remainingPath: string,
  state: State,
  params?: AxiosRequestConfig['params'],
) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.get(`${baseOrderNonExternalApiUrl}${remainingPath}`, {
        ...config,
        headers: {
          ...config.headers,
          ...impersonationHeader,
        },
        params,
      })
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
